<mat-dialog-content class="container">
  @if (
    !(productsInBasketCartWithPhotos$ | async)?.length &&
    !(productInPackageInBasket$ | async)?.length &&
    !(visibleFiles$ | async)?.length &&
    !(visiblePrints$ | async)?.length &&
    !(visibleProducts$ | async)?.length &&
    (packagesInShop$ | async).package.length > 0
  ) {
    <div class="information">
      <h2 translate>clhkc16pm000008lchjbq9blg</h2>
      <lib-button
        (click)="goToPackageMenu.emit()"
        forceContext="productFront"
        translate
        >clhkc1dxy000108lc9h38bsyw
      </lib-button>
    </div>
  } @else {
    <ng-template [ngTemplateOutlet]="sellProducts"></ng-template>
  }
  <ng-template #sellProducts>
    @if (!(isPhonePortrait$ | async)) {
      <ng-scrollbar>
        <ng-container *ngTemplateOutlet="productList"></ng-container>
      </ng-scrollbar>
    }
    @if (!(isPhonePortrait$ | async)) {
    } @else {
      <ng-template [ngTemplateOutlet]="productList"></ng-template>
    }
  </ng-template>
</mat-dialog-content>
<mat-dialog-content class="buttons">
  <lib-button (click)="closeDialog.emit()" forceContext="common" translate
    >comeBack
  </lib-button>
  <span>
    @if ((allProductsInBasket$ | async)?.length) {
      <span class="price">
        ({{ currentBasketValue$ | async | pricePicker }})
      </span>
    }
    <lib-button (click)="showBasket()" forceContext="productFront" translate
      >basket</lib-button
    >
  </span>
</mat-dialog-content>

<ng-template #productList>
  @if (
    !(isPhonePortrait$ | async) &&
    !(
      (productsInBasketCartWithPhotos$ | async)?.length ||
      (productInPackageInBasket$ | async)?.length
    )
  ) {
  } @else {
    <ng-template [ngTemplateOutlet]="productsInBasket"></ng-template>
  }
  @if (
    !(isPhonePortrait$ | async) &&
    ((productsInBasketCartWithPhotos$ | async)?.length ||
      (productInPackageInBasket$ | async)?.length) &&
    (visibleFiles$ | async)?.length
  ) {
    <div class="line"></div>
  }
  @if ((visibleFiles$ | async)?.length && isPhonePortrait$ | async) {
    <div class="filesOnPhone">
      @if (!(visibleFiles$ | async)?.length) {
      } @else {
        <ng-template [ngTemplateOutlet]="visibleFiles"></ng-template>
      }
    </div>
  }

  <div class="allProducts">
    @if (!(isPhonePortrait$ | async)) {
      @if (!(visibleFiles$ | async)?.length) {
      } @else {
        <ng-template [ngTemplateOutlet]="visibleFiles"></ng-template>
      }
    }
    @if (
      !(isPhonePortrait$ | async) &&
      (visibleFiles$ | async)?.length &&
      (visiblePrints$ | async)?.length
    ) {
      <div class="line"></div>
    }
    @if (!(visiblePrints$ | async)?.length) {
    } @else {
      <ng-template [ngTemplateOutlet]="visiblePrints"></ng-template>
    }
    @if (
      !(isPhonePortrait$ | async) &&
      (visiblePrints$ | async)?.length &&
      (visibleProducts$ | async)?.length
    ) {
      <div class="line"></div>
    }
    @if (sellZalamoCalendar) {
      <div class="calendar title">
        @if (
          photoId
            | lookBookSingleWallDecorPreview
              : (allImages$ | async)
              : zalamoCalendarProductType
            | async;
          as calendarPreview
        ) {
          <lib-wall-decor-preview
            (fakeUpdate)="
              calendarThumbInBasket.setValue(calendarPreview.fileName);
              calendarCropInBasket.setValue(calendarPreview.images[0].crop)
            "
            [config]="calendarPreview"
            [isCalendar]="true"
          >
          </lib-wall-decor-preview>
          <div class="calendarSizeInfor">
            <strong>Wymiary</strong>
            @if ((photoRatio$ | async) >= 1) {
              zdjęcie: 29 x 19 cm, kalendarium: 19 x 29cm, całkowite: 38 x 29 cm
            } @else {
              <ng-template [ngTemplateOutlet]="verticalWidth"></ng-template>
            }
            <ng-template #verticalWidth>
              zdjęcie: 29 x 43.5 cm, kalendarium: 19 x 29 cm, całkowite: 29 x
              64cm
            </ng-template>
          </div>
          <h3>
            Kalendarz
            @if ((photoRatio$ | async) >= 1) {
              poziomy
            } @else {
              <ng-template [ngTemplateOutlet]="vertical"></ng-template>
            }
            <ng-template #vertical>pionowy</ng-template>
            {{
              photoRatio$
                | async
                | pickCalendarPrice: calendarPrices
                | pricePicker
            }}
            <app-change-number [minNumber]="0" [formControl]="calendarInBasket">
            </app-change-number>
          </h3>
          <!--        <div>-->
          <!--          <lib-button-->
          <!--            *libIsHandset="desktop"-->
          <!--            (click)="editWallDecor(calendarPreview)"-->
          <!--            forceContext="productFront"-->
          <!--            translate-->
          <!--            >clhn4lf37000108mnhe9ucxt2-->
          <!--          </lib-button>-->
          <!--          <ng-template #desktop>-->
          <!--            <lib-button-->
          <!--              (click)="editWallDecor(calendarPreview)"-->
          <!--              lg-->
          <!--              forceContext="productFront"-->
          <!--              translate-->
          <!--              >clhn4lf37000108mnhe9ucxt2-->
          <!--            </lib-button>-->
          <!--          </ng-template>-->
          <!--        </div>-->
        } @else {
          <ng-template [ngTemplateOutlet]="calendarSkeleton"></ng-template>
        }
        <ng-template #wallDecorSkeleton>
          <div class="skeleton">
            <div class="image"></div>
            <div class="action">
              <lib-button lg forceContext="productFront" translate
                >clhn4lf37000108mnhe9ucxt2
              </lib-button>
            </div>
          </div>
        </ng-template>
        <ng-template #calendarSkeleton>
          <div class="skeleton">
            <div class="image"></div>
          </div>
        </ng-template>
      </div>
    }
    @if (sellZalamoMagnet) {
      @for (
        offer of magnetOffers$ | async;
        track trackMagnetOffer($index, offer)
      ) {
        <div class="magnet title">
          <h3>
            Magnes {{ offer.label }} na lodówkę
            {{ offer.price | pricePicker }}
            <app-change-number
              [minNumber]="0"
              [number]="offer.count"
              (newNumber)="
                magnetCountChanges$.next({
                  sizeId: offer.sizeId,
                  count: $event,
                })
              "
            ></app-change-number>
          </h3>
        </div>
      }
    }
    @if (!(lookBookEnabled$ | async)) {
    } @else {
      <ng-template [ngTemplateOutlet]="lookBookProducts"></ng-template>
    }
    @if (
      !(
        (visibleProducts$ | async)?.length ||
        (productInPackage$ | async)?.length
      )
    ) {
    } @else {
      <ng-template [ngTemplateOutlet]="visibleProducts"></ng-template>
    }
  </div>
</ng-template>
<ng-template #productsInBasket>
  @if (!(isPhonePortrait$ | async)) {
    <h3 translate>clhkdmlvk000008mjflwn0hlj</h3>
  }
  @for (products of productInPackageInBasket$ | async; track products) {
    @for (product of products.products; track product) {
      <div class="productInBasket">
        @if (!product.max && !product.thisPhotoIsAdd) {
          <lib-button
            (click)="addPhotoToProductInPackage(product.selectedProductId)"
            forceContext="productFront"
            translate
            >clhkg23eu000008kxdvoc5tmp
          </lib-button>
        }
        @if (product.thisPhotoIsAdd) {
          <lib-button
            (click)="removePhotoToProductInPackage(product.selectedProductId)"
            forceContext="productFront"
            translate
            >clhkg28g6000108kx1rib3cea
          </lib-button>
        }
        @if (product.max && !product.thisPhotoIsAdd) {
          <lib-button
            (click)="swapPhotoToProductInPackage(product.selectedProductId)"
            forceContext="productFront"
            translate
            >clhkg2dxu000208kx16xz6dsr
          </lib-button>
        }
        <mat-icon class="arrow">arrow_forward</mat-icon>
        @if (product.nameClientProduct?.length) {
          <div>
            {{ product.nameClientProduct }}
          </div>
        }
        @if (!product.nameClientProduct?.length) {
          <div>
            @if ((product.customName | langPicker | async)?.length) {
              {{ product.customName | langPicker | async }}
            }
            @if (!(product.customName | langPicker | async)?.length) {
              {{ (product.productId | productInShop | async).name }}
            }
          </div>
        }
        <button
          (click)="
            previewSelectedProductInPacket(products.packageInBasketId, product)
          "
          mat-icon-button
        >
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    }
  }
  @for (product of productsInBasketCartWithPhotos$ | async; track product) {
    <div class="productInBasket">
      @if (!product.max && !product.thisPhotoIsAdd) {
        <lib-button
          (click)="addPhotoToProduct(product.selectedProductId)"
          forceContext="productFront"
          translate
          >clhkg23eu000008kxdvoc5tmp
        </lib-button>
      }
      @if (product.thisPhotoIsAdd) {
        <lib-button
          (click)="removePhotoToProduct(product.selectedProductId)"
          forceContext="productFront"
          translate
          >clhkg28g6000108kx1rib3cea
        </lib-button>
      }
      @if (product.max && !product.thisPhotoIsAdd) {
        <lib-button
          (click)="swapPhotoToProduct(product.selectedProductId)"
          forceContext="productFront"
          translate
          >clhkg2dxu000208kx16xz6dsr
        </lib-button>
      }
      <mat-icon class="arrow">arrow_forward</mat-icon>
      @if (product.nameClientProduct) {
        <div>{{ product.nameClientProduct }}</div>
      }
      @if (!product.nameClientProduct) {
        <div>{{ product.name }}</div>
      }
      <button (click)="editProduct(product.selectedProductId)" mat-icon-button>
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  }
</ng-template>

<ng-template #visibleFiles [formGroup]="model">
  @if (!(isPhonePortrait$ | async)) {
    <h3 class="title" translate>clhkibet0000008jl7g3d3bei</h3>
  }
  @for (
    file of visibleFiles$ | async;
    track trackFile(i, file);
    let i = $index
  ) {
    <div #windowFiles class="name">
      <lib-checkbox [formControlName]="file.size">
        @if (file.isFull) {
          <span>{{ file.isFull | fileName | async | langPicker | async }}</span>
        }
        @if (!file.isFull) {
          <span><span translate>file</span> {{ file.size }}px</span>
        }
      </lib-checkbox>
    </div>
    <div class="price">
      @if (file.onlyPackage) {
        <span translate>clhkiljv9000208mq8dama6ow</span>
      } @else {
        <ng-template [ngTemplateOutlet]="notOnlyInPackage"></ng-template>
      }
      <ng-template #notOnlyInPackage>
        @if (file.inPackage && file.freeSpaceInPackage !== 0) {
          <span translate> clhkilpti000308mq2clmf6tq </span>
        } @else {
          <ng-template [ngTemplateOutlet]="outsidePackage"></ng-template>
        }
        <ng-template #outsidePackage>
          <span>{{ file.price | pricePicker }}</span>
        </ng-template>
      </ng-template>
    </div>
    @if (!!file.inBasket && !!(retouchLevels$ | async)?.length) {
      @for (retouch of retouchLevels$ | async; track retouch) {
        <ng-container class="">
          <div class="nameRetouch name">
            <lib-checkbox
              (change)="changeRetouchFile(retouch.retouchLevelId)"
              [checked]="retouch.selected"
            >
              {{ retouch.label | langPicker | async }}
            </lib-checkbox>
          </div>
          <div class="price">+{{ retouch.price | pricePicker }}</div>
        </ng-container>
      }
    }
  }
</ng-template>

<ng-template #visiblePrints>
  @if (!(isPhonePortrait$ | async)) {
    <h3 class="title" translate>clhkk55p8000008l79rn499cq</h3>
  }
  <ng-container *libIsHandset="desktopPrints">
    @for (print of visiblePrints$ | async; track trackPrint($index, print)) {
      <div class="name">
        <span>
          {{ print.printFormatId | printFormatLabel | async }}
          {{ print.printPaperId | printPaperLabel | async }}
        </span>
        <button
          (click)="showPrintDetails(print.printFormatId, print.printPaperId)"
          mat-icon-button
        >
          <mat-icon>info_outline</mat-icon>
        </button>
      </div>
      <div class="price">
        <ng-container
          *ngTemplateOutlet="pricePrint; context: { print: print }"
        ></ng-container>
      </div>
      <div class="count">
        <ng-container
          *ngTemplateOutlet="countPrint; context: { print: print }"
        ></ng-container>
      </div>
      @if (
        sellPrintFrames &&
          (print.countInBasket ||
            print.countInPackageInBasket ||
            print.countInTogetherWithFile) &&
          print.printFormatId
          | sizeAvailableInPrintFrames
          | async
      ) {
        <div class="pickFrame" animate.enter="frame-enter">
          <h3 translate>clhkk5e6r000108l74qd0gt1j</h3>
          <lib-print-frames-picker
            [printSizeId]="print.printFormatId"
            [ratio]="photoRatio$ | async"
            [context]="context"
            [contextId]="contextId"
            [photoId]="currentPhotoId$ | async"
          ></lib-print-frames-picker>
        </div>
      }
    }
  </ng-container>
  <ng-template #desktopPrints>
    @for (print of visiblePrints$ | async; track trackPrint($index, print)) {
      <div class="print name">
        <button
          (click)="showPrintDetails(print.printFormatId, print.printPaperId)"
          class="info-button"
          mat-icon-button
        >
          <mat-icon>info_outline</mat-icon>
        </button>
        {{ print.printFormatId | printFormatLabel | async }}
        {{ print.printPaperId | printPaperLabel | async }}
      </div>
      <div class="print price">
        <ng-container
          *ngTemplateOutlet="pricePrint; context: { print: print }"
        ></ng-container>
      </div>
      <div class="print count">
        <ng-container
          *ngTemplateOutlet="countPrint; context: { print: print }"
        ></ng-container>
      </div>
      @if (
        sellPrintFrames &&
          (print.countInBasket ||
            print.countInPackageInBasket ||
            print.countInTogetherWithFile) &&
          print.printFormatId
          | sizeAvailableInPrintFrames
          | async
      ) {
        <div class="pickFrame" animate.enter="frame-enter">
          <h3 translate>clhkk5e6r000108l74qd0gt1j</h3>

          <lib-print-frames-picker
            [printSizeId]="print.printFormatId"
            [ratio]="photoRatio$ | async"
            [context]="context"
            [contextId]="contextId"
            [photoId]="currentPhotoId$ | async"
          ></lib-print-frames-picker>
        </div>
      }
    }
  </ng-template>
</ng-template>

<ng-template #pricePrint let-print="print">
  @if (print.inPackage && !print.onlyPackage) {
    <span translate>clhkkwfmr000108laenu49r0c</span>
  }
  @if (print.inPackage && print.onlyPackage) {
    <span translate>clhkkwld4000208ladzjehs59</span>
  }
  @if (!print.inPackage) {
    @if ((addToFirstPrintPrice$ | async)?.addToFirstPrintPrice) {
      @if (!print.price.length) {
        <span translate>clhkl40qg000408ladeuq81hx</span>
      }
      @if (print.price.length) {
        <span>{{
          print.price | pricePicker: (addToFirstPrintPrice$ | async).price
        }}</span>
      }
    } @else {
      <ng-template [ngTemplateOutlet]="simplePrice"></ng-template>
    }
    <ng-template #simplePrice>
      @if (!print.price.length) {
        <span translate>clhkl40qg000408ladeuq81hx</span>
      }
      @if (print.price.length) {
        <span>{{ print.price | pricePicker }}</span>
      }
    </ng-template>
  }
</ng-template>

<ng-template #countPrint let-print="print">
  <app-change-number
    #target
    (numberDifference)="changePrintQuantity($event, print, target)"
    [maxNumber]="
      print.maxNumber +
      print.countInPackage -
      print.countInPackageInBasket +
      print.printPhoto
    "
    [minNumber]="print.minNumber"
    [number]="
      print.countInBasket + print.printPhoto + print.countInTogetherWithFile
    "
    [showMax]="true"
  >
  </app-change-number>
</ng-template>

<ng-template #lookBookProducts>
  @if (sellLookBookWallDecor || sellLookBookTambour) {
    <h3 class="title" translate>clhn4l5xe000008mn0bcl9xa9</h3>
  }
  <div class="LookBook title">
    @if (sellLookBookWallDecor) {
      <div class="walldecor">
        @if (
          photoId
            | lookBookSingleWallDecorPreview: (allImages$ | async)
            | async;
          as wallDecorPreview
        ) {
          <lib-wall-decor-preview
            (click)="editWallDecor(wallDecorPreview)"
            [config]="wallDecorPreview"
          >
          </lib-wall-decor-preview>
          <div>
            <lib-button
              *libIsHandset="desktop"
              (click)="editWallDecor(wallDecorPreview)"
              forceContext="productFront"
              translate
              >clhn4lf37000108mnhe9ucxt2
            </lib-button>
            <ng-template #desktop>
              <lib-button
                (click)="editWallDecor(wallDecorPreview)"
                lg
                forceContext="productFront"
                translate
                >clhn4lf37000108mnhe9ucxt2
              </lib-button>
            </ng-template>
          </div>
        } @else {
          <ng-template [ngTemplateOutlet]="wallDecorSkeleton"></ng-template>
        }
        <ng-template #wallDecorSkeleton>
          <div class="skeleton">
            <div class="image"></div>
            <div class="action">
              <lib-button lg forceContext="productFront" translate
                >clhn4lf37000108mnhe9ucxt2
              </lib-button>
            </div>
          </div>
        </ng-template>
      </div>
    }
    @if (sellLookBookTambour) {
      <div class="walldecor">
        @if (
          photoId
            | lookBookSingleWallDecorPreview
              : (allImages$ | async)
              : tambourProductType
            | async;
          as tambourPreview
        ) {
          <lib-wall-decor-preview
            (click)="editTambour(tambourPreview)"
            [config]="tambourPreview"
          >
          </lib-wall-decor-preview>
          <div>
            <lib-button
              *libIsHandset="desktop"
              (click)="editTambour(tambourPreview)"
              forceContext="productFront"
              translate
              >clhn4lf37000108mnhe9ucxt2
            </lib-button>
            <ng-template #desktop>
              <lib-button
                (click)="editTambour(tambourPreview)"
                lg
                forceContext="productFront"
                translate
                >clhn4lf37000108mnhe9ucxt2
              </lib-button>
            </ng-template>
          </div>
        } @else {
          <ng-template [ngTemplateOutlet]="tambourSkeleton"></ng-template>
        }
        <ng-template #tambourSkeleton>
          <div class="skeleton">
            <div class="image"></div>
            <div class="action">
              <lib-button lg forceContext="productFront" translate
                >clhn4lf37000108mnhe9ucxt2
              </lib-button>
            </div>
          </div>
        </ng-template>
      </div>
    }
  </div>
</ng-template>
<ng-template #visibleProducts>
  @if (!(isPhonePortrait$ | async)) {
    <h3 class="title" translate>clhn4sj7c000008jpcuiccu4h</h3>
  }
  <ng-container *libIsHandset="desktopProducts">
    @for (products of productInPackage$ | async; track products) {
      @for (product of products.products; track product) {
        <div class="name">
          @if ((product.customName | langPicker | async)?.length) {
            <div>
              {{ product.customName | langPicker | async }}
            </div>
          }
          @if (!(product.customName | langPicker | async)?.length) {
            <div>
              {{ (product.productId | productInShop | async).name }}
            </div>
          }
          <button
            (click)="
              previewProductInPacket(product, products.packageInBasketId)
            "
            mat-icon-button
          >
            <mat-icon>info_outline</mat-icon>
          </button>
        </div>
        <div class="price">
          <span translate>clhn5kfui000109jqf2828008</span>
        </div>
        <div class="count">
          <lib-button
            (click)="
              previewProductInPacket(product, products.packageInBasketId)
            "
            forceContext="productFront"
            translate
            >clhn5l1an000209jq3uq70ohl
          </lib-button>
        </div>
      }
    }
    @for (product of visibleProducts$ | async; track product) {
      <div class="name">
        <div>{{ product.name }}</div>
        <button (click)="previewProduct(product)" mat-icon-button>
          <mat-icon>info_outline</mat-icon>
        </button>
      </div>
      <div class="price">
        <span>
          {{
            product
              | priceWithConfigParser: {} : [{ photoId: photoId }] : 'base'
              | async
              | pricePicker
          }}
        </span>
      </div>
      <div class="count">
        <lib-button
          (click)="previewProduct(product)"
          forceContext="productFront"
          translate
          >clhn5l1an000209jq3uq70ohl
        </lib-button>
      </div>
    }
  </ng-container>
  <ng-template #desktopProducts>
    @for (products of productInPackage$ | async; track products) {
      @for (product of products.products; track product) {
        <div class="product name">
          <button
            (click)="
              previewProductInPacket(product, products.packageInBasketId)
            "
            class="info-button"
            mat-icon-button
          >
            <mat-icon>info_outline</mat-icon>
          </button>
          @if ((product.customName | langPicker | async)?.length) {
            <div
              (click)="
                previewProductInPacket(product, products.packageInBasketId)
              "
            >
              {{ product.customName | langPicker | async }}
            </div>
          }
          @if (!(product.customName | langPicker | async)?.length) {
            <div
              (click)="
                previewProductInPacket(product, products.packageInBasketId)
              "
            >
              {{ (product.productId | productInShop | async).name }}
            </div>
          }
        </div>
        <div class="product price">
          <span translate>clhn5kfui000109jqf2828008</span>
        </div>
        <div class="product count">
          <lib-button
            (click)="
              previewProductInPacket(product, products.packageInBasketId)
            "
            forceContext="productFront"
            translate
          >
            clhn5l1an000209jq3uq70ohl
          </lib-button>
        </div>
      }
    }
    @for (product of visibleProducts$ | async; track product) {
      <div class="product name">
        <button
          (click)="previewProduct(product)"
          class="info-button"
          mat-icon-button
        >
          <mat-icon>info_outline</mat-icon>
        </button>
        <div (click)="previewProduct(product)">{{ product.name }}</div>
      </div>
      <div class="product price">
        <span>
          {{
            product
              | priceWithConfigParser: {} : [{ photoId: photoId }] : 'base'
              | async
              | pricePicker
          }}
        </span>
      </div>
      <div class="product count">
        <lib-button
          (click)="previewProduct(product)"
          forceContext="productFront"
          translate
          >clhn5l1an000209jq3uq70ohl
        </lib-button>
      </div>
    }
  </ng-template>
</ng-template>

<ng-template #messageAboutChangingThePhotoInTheProduct>
  <div class="message">
    <div>
      <h2 translate>clhn5xqj7000008mm33jf5t7k</h2>
      <h2 translate>clhn5xy0g000108mm7zg62fdp</h2>
      <p>
        <lib-button (click)="swapPhoto$.next(true)" lg translate
          >true
        </lib-button>
        <lib-button (click)="swapPhoto$.next(false)" lg translate
          >false
        </lib-button>
      </p>
    </div>
  </div>
</ng-template>
<ng-template #messageAboutSurchargeForFile>
  <div class="centerPoint">
    <h1 translate>clhn5yjkj000208mmaq0512ea</h1>
  </div>
</ng-template>
